import React from "react";

export default function NormBadge({ std, size = "sm", showShort = true }) {
  if (!std) return null;
  const dotSize = size === "xs" ? "w-2 h-2" : size === "md" ? "w-3.5 h-3.5" : "w-2.5 h-2.5";
  const textSize = size === "xs" ? "text-[9px]" : size === "md" ? "text-[12px]" : "text-[11px]";
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={`${dotSize} rounded-sm flex-shrink-0`}
        style={{ backgroundColor: std.color || "#94a3b8" }}
        aria-hidden="true"
      />
      {showShort && (
        <span className={`${textSize} font-medium tabular-nums tracking-tight`}>
          {std.short}
        </span>
      )}
    </span>
  );
}
